export const COUNTRY_ADDRESS_FIELDS = {
	quarter: ['bg'],
	streetNumber: ['ro', 'bg'],
	entrance: ['ro', 'bg'],
	staircase: ['ro'],
	floor: ['ro', 'bg'],
	businessOrComplexName: ['bg'],
};

export const REQUIRED_FIELDS_FOR_COUNTRY = {
	building: ['sk'],
};
